import React, { useState } from 'react';
import { useLoadingScreen } from '../../Store/LoadingManager';

import { useNavigate } from "react-router-dom";
import { useSnackbar } from "notistack";

import { Typography, Box } from "@mui/material";
import { OTPContainer, OTPStyledCard } from '../../Styles/Authentication/authenticationStyles';

import { useAuthenticationHook } from '../../Hooks/Authentication/authenticationHooks';

import { Authentication } from '../../Models/Authentication/Authentication';

import RequiredParametersHelper from '../../Utilities/Helpers/RequiredParametersHelper';
import RequiredFieldHelper from '../../Utilities/Helpers/RequiredFieldHelper';
import RouteHelper from '../../Utilities/Helpers/RouteHelper';
import LocalStorageHelper from '../../Utilities/Helpers/LocalStorageHelper';

import { RouteEnum } from '../../Utilities/Enums/RouteEnums';
import { ButtonType } from '../../Utilities/Enums/ButtonTypeEnum';
import { AuthenticationField } from '../../Utilities/Enums/ParametersEnum';

import { AssetImages } from "../../Constants/Assets";
import { SuccessMessage, ErrorMessage } from '../../Constants/Messages';

import CustomButton from '../../CustomViews/Elements/CustomButton';
import FormTextField from '../../CustomViews/Elements/FormTextField';
import AuthFooter from './AuthFooter';

export default function OTP() {
    const navigate = useNavigate();
    const { verifyLogin2FA } = useAuthenticationHook();
    const { enqueueSnackbar } = useSnackbar();
    let requiredFields = RequiredParametersHelper.otpCode();
    const _userData: Authentication = LocalStorageHelper.getUserData();
    const { loading, setLoading } = useLoadingScreen();

    //Use States
    let [authCode, setauthCode] = useState<any>("");
    const [errorMessages, setErrorMessages]: any = useState({});
    const [loginResponse, setLoginResponse]: any = useState({});

    //Variables
    const authCodeProps = {
        name: "code",
        title: 'OTP',
        placeholder: 'OTP',
        fieldValue: authCode ?? "",
        type: 'text',
        required: requiredFields?.find((field: any) => field.keyName == "code")?.keyName != null,
        hideLabel: true,
        errorMessages: errorMessages,
        maxLength: 6,
        handleOnChange: (selectedValue: any) => {
            setauthCode(selectedValue);
        },
    };

    //Event Handlers
    const handleSubmit = async () => {
        let _formData = {
            token: _userData?.[AuthenticationField.TOKEN] ?? "",
            code: authCode,
        }
        setLoginResponse({ isLoading: true, data: null, errorMessage: '' });

        let _validateForm = RequiredFieldHelper.validateForm(requiredFields, _formData, errorMessages, setErrorMessages, enqueueSnackbar);

        if (_validateForm?.hasError) { return true; }

        setLoading(true);
        
        let otpResponse = await verifyLogin2FA(JSON.stringify(_formData));

        if (otpResponse && otpResponse.isSuccess && otpResponse.data) {
            navigate(RouteEnum.DASHBOARD, { replace: true });
            navigate(0);

            otpResponse.errorMessage = (otpResponse && otpResponse.data && otpResponse.data.message && otpResponse.data.message != null && otpResponse.data.message != "" ?
                otpResponse.data.message : SuccessMessage.LOGIN_SUCCESSFULLY
            );
        } else {
            otpResponse.errorMessage = otpResponse?.message ?? ErrorMessage.SERVER_ERROR
        }

        setLoading(false);
        otpResponse.errorCode = (otpResponse.isSuccess ? 200 : 400);

        setLoginResponse({ ...otpResponse, isLoading: false });
    }

    //Rendering Functions
    return <OTPContainer className='glossy-box'>
        <div className="otpBgContainer">
            <OTPStyledCard elevation={3}>
                <div className="otpFormContainer">
                    <div className="formContainer">
                        <img src={AssetImages.WEB_APP_LOGO} />
                        <Typography color="primaryText" className="headerText">{RouteHelper.getRouteDescription(RouteEnum.OTP)}</Typography>
                        <Typography color="primaryText" className="subHeaderText">Please enter the OTP generated from your authenticator app on mobile.</Typography>
                        

                        <div className="fieldsContainer">
                            <FormTextField {...authCodeProps} />
                            <div className="recoverAccountLink" onClick={() => { navigate(RouteEnum.RECOVER_ACCOUNT, { replace: true }); }}>Recover Account</div>
                        </div>

                        {loginResponse?.message &&
                            <Box
                                sx={{ typography: 'subtitle2' }}
                                className={`loginErrorMessage${(loginResponse?.errorCode && loginResponse.errorCode == '200' ? ' successMessage' : ' errorMessage')}`} >
                                {loginResponse.message}
                            </Box>
                        }

                        <CustomButton
                            btnType={ButtonType.PRIMARY}
                            title='Submit'
                            className="submitBtn"
                            onClick={(e: any) => {
                                handleSubmit();
                            }} />

                        <div className="goBackLink" onClick={() => { navigate(RouteEnum.LOGIN, { replace: true }); }}>Go Back</div>
                    </div>

                    <div className="spacer2" />
                    
                    <AuthFooter />
                </div>
            </OTPStyledCard>
        </div>
    </OTPContainer>
}